module.exports = __webpack_public_path__ + "static/media/SierFemale.bc4d3a1d.svg";